import { render, staticRenderFns } from "./Tienda.vue?vue&type=template&id=070c3628&"
import script from "./Tienda.vue?vue&type=script&lang=js&"
export * from "./Tienda.vue?vue&type=script&lang=js&"
import style0 from "./Tienda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports